/** Facebook / Instagram – koristi se u Navbar, Footer, SocialLinks. */
export const SOCIAL_URL = {
  facebook: "https://www.facebook.com/profile.php?id=61574238266662",
  instagram: "https://www.instagram.com/travelina_travelina/",
};
